
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
//window.Vue = require('vue');
require('./laravel-ajax-form.js');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

//const app = new Vue({
//    el: '#app'
//});


// change icon on collapsible headers dependent on state.
var collapseHeaderList = $(".card-header[data-toggle='collapse']");
collapseHeaderList.each(function (index, element) {
    var $panel = $(element.dataset.target);
    var $trigger = $(this);
    // attach events
    $panel.on('hidden.bs.collapse', function (event) {
        if (this == event.target) {
            $trigger.find('.panel-state-indicator').remove();
            $trigger.append('<i class="panel-state-indicator float-right icon-down-open"></i>');
        }
    });
    $panel.on('shown.bs.collapse', function (event) {
        if (this == event.target) {
            $trigger.find('.panel-state-indicator').remove();
            $trigger.append('<i class="panel-state-indicator float-right icon-up-open"></i>');
        }
    });

    // and set the initial state.
    if ($panel.hasClass('show')) {
        $trigger.append('<i class="panel-state-indicator float-right icon-up-open"></i>');
    } else {
        $trigger.append('<i class="panel-state-indicator float-right icon-down-open"></i>');
    }
});

function fallbackCopyTextToClipboard(text, successText, errorText) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        if (successful) {
            alert(successText || "Text Successfully Copied!");
        } else {
            alert(errorText || "Error copying to clipboard!");
        }
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        alert(errorText || "Error copying to clipboard!")
    }

    document.body.removeChild(textArea);
}

window.copyTextToClipboard = function(text, successText, errorText) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, successText);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        alert(successText || "Text Successfully Copied!")
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
        alert(errorText || "Error copying to clipboard!")
    });
}
